export enum ATTACHMENT_ACTION_TYPES {
    UPLOAD_ATTACHMENT_START = 'attachment/UPLOAD_ATTACHMENT_START',
    UPLOAD_ATTACHMENT_SUCCESS = 'attachment/UPLOAD_ATTACHMENT_SUCCESS',
    UPLOAD_ATTACHMENT_FAILED = 'attachment/UPLOAD_ATTACHMENT_FAILED',
    APPROVE_ATTACHMENT_START = 'attachment/APPROVE_ATTACHMENT_START',
    APPROVE_ATTACHMENT_SUCCESS = 'attachment/APPROVE_ATTACHMENT_SUCCESS',
    APPROVE_ATTACHMENT_FAILED = 'attachment/APPROVE_ATTACHMENT_FAILED',
    REJECT_ATTACHMENT_START = 'attachment/REJECT_ATTACHMENT_START',
    REJECT_ATTACHMENT_SUCCESS = 'attachment/REJECT_ATTACHMENT_SUCCESS',
    REJECT_ATTACHMENT_FAILED = 'attachment/REJECT_ATTACHMENT_FAILED',
    REPLACE_ATTACHMENT_START = 'attachment/REPLACE_ATTACHMENT_START',
    REPLACE_ATTACHMENT_SUCCESS = 'attachment/REPLACE_ATTACHMENT_SUCCESS',
    REPLACE_ATTACHMENT_FAILED = 'attachment/REPLACE_ATTACHMENT_FAILED',
    CREATE_SCENE_3D_START = 'attachment/CREATE_SCENE_3D_START',
    CREATE_SCENE_3D_SUCCESS = 'attachment/CREATE_SCENE_3D_SUCCESS',
    CREATE_SCENE_3D_FAILED = 'attachment/CREATE_SCENE_3D_FAILED',
    SHARE_SCENE_3D_START = 'attachment/SHARE_SCENE_3D_START',
    SHARE_SCENE_3D_SUCCESS = 'attachment/SHARE_SCENE_3D_SUCCESS',
    SHARE_SCENE_3D_FAILED = 'attachment/SHARE_SCENE_3D_FAILED',
    SEND_SHARE_CODE_MAIL_START = 'attachment/SEND_SHARE_CODE_MAIL_START',
    SEND_SHARE_CODE_MAIL_SUCCESS = 'attachment/SEND_SHARE_CODE_MAIL_SUCCESS',
    SEND_SHARE_CODE_MAIL_FAILED = 'attachment/SEND_SHARE_CODE_MAIL_FAILED',
}
